import { Injectable, Injector, Inject, Optional } from '@angular/core';
import { PlatformInformationService } from '../../../../projects/platform-manager/src/public_api';
import { Response } from 'express';
import { environment } from '../../../environments/environment';

/**
 * This service is used to add so called "surrogate" headers to page responses
 * from the Angular SSR (server side rendering) run. It is mostly used inside API calls/services
 * to add information when embedding results from api calls on the page
 */
@Injectable({
  providedIn: 'root'
})
export class SurrogateKeyService {

  constructor(
    @Optional() @Inject('RESPONSE') private res: Response,
    private injector: Injector,
    private platformService: PlatformInformationService
  ) {
    if (!this.platformService.getIsBrowser()) {
      const env = this.injector.get('DOCKERENV');
      this.addSurrogateKeys(['all', 'alpinresorts-angular', env]);
    }
  }

  addSurrogateKeys(keys: Array<string>) {
    if (!this.platformService.getIsBrowser()) {
      if (environment.surrogateKeyPrefixActive){
        keys = keys.map(k => `frontend-${k}`)
      }

      const header: string = this.res?.getHeader('Surrogate-Key') as string;
      if (header) {
        keys = header.split(' ').concat(keys);
      }
      // strip duplicate keys
      keys = this.stripDoublicates(keys);

      this.res?.setHeader('Surrogate-Key', keys.join(' ').trim());
    }
  }

  /**
   * Strips double keys from a given array
   * @param keys string array that can contain doublicate entries
   */
  private stripDoublicates(keys: Array<string>): Array<string> {
    return keys.reduce(function (a, b) {
      if (a.indexOf(b) < 0) { a.push(b); }
      return a;
    }, []);
  }
}
